// Module
var code = "<div class=\"row\"> <form class=\"col-sm-6 offset-sm-3 col-md-4 offset-md-4\"> </form> </div>";
// Exports
module.exports = code;